import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CartCouponModule } from '@spartacus/cart/base/components';
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  provideConfig,
  UrlModule
} from '@spartacus/core';
import { ProgressButtonModule, SpinnerModule } from '@spartacus/storefront';
import { UNAVAILABLE_PRODUCTS_FEATURE } from 'src/app/custom/cart/unavailable-products/store/custom-unavailable-products-state';
import { effectsUnavailableProducts } from 'src/app/custom/cart/unavailable-products/store/effects/custom-unavailable-products.effect';
import { reducerUnavailableProductsProvider, reducerUnavailableProductsToken } from 'src/app/custom/cart/unavailable-products/store/reducers/custom-unavailable-products.reducer';
import { CustomCartSharedModule } from '../custom-cart-shared/custom-cart-shared.module';
import { CustomCartTotalsComponent } from './custom-cart-totals.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    //CartSharedModule,
    CustomCartSharedModule,
    I18nModule,
    CartCouponModule,
    FeaturesConfigModule,
    ProgressButtonModule,
    SpinnerModule,
    //EffectsModule.forFeature(effectsRealtimeStock),
    EffectsModule.forFeature(effectsUnavailableProducts),
    StoreModule.forFeature(UNAVAILABLE_PRODUCTS_FEATURE, reducerUnavailableProductsToken),
  ],
  providers: [
    reducerUnavailableProductsProvider,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartTotalsComponent: {
          component: CustomCartTotalsComponent,
        },
      },
    })
  ],
  declarations: [CustomCartTotalsComponent],
  exports: [CustomCartTotalsComponent]
})
export class CustomCartTotalsModule { }
